import React from 'react';
import styles from './LinkToArea.styles';
import { useDispatch, useSelector } from 'react-redux';
import { selectArea } from '../../redux/store/appData/areas';
import { AreaData } from '../../@types';
import { selectPricing } from '../../redux/store/appData/pricings';
import { selectTrip } from '../../redux/store/userData/trips';
import { selectSelectedDrawersCount } from '../../redux/store/ui/common';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

interface Props {
  text?: string;
  area?: AreaData;
  params?: any;
}

const LinkToArea: React.FC<Props> = ({ text, area }) => {
  const dispatch = useDispatch();
  const openedDrawersCount = useSelector(selectSelectedDrawersCount);

  if (!area) {
    return <span>{text}</span>;
  }

  const onClickHandler = (e: any) => {
    e.preventDefault();
    if (area != null && openedDrawersCount < 2) {
      dispatch(selectArea(area));
      dispatch(selectTrip(null));
      dispatch(selectPricing(null));
    }
  };
  return (
    <>
      {openedDrawersCount < 2 ? (
        <span
          data-testid={`LinkToArea-carAreaLink-${text}`}
          className="link"
          onClick={onClickHandler}
        >
          {text || '-'}
        </span>
      ) : (
        <Link
          replace={false}
          to={{
            pathname: '/dashboard',
            search: `?vm=AREA&type=TABLE&areaId=${area.id}`,
          }}
          target="_blank"
        >
          <a className="external-link-wrapper" target="_blank" rel="noreferrer">
            <span className="link">{text}</span>
            <ExportOutlined
              color="#0077be"
              style={{ fontSize: '18px', marginLeft: '10px' }}
            />
          </a>
        </Link>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToArea;
